const breakpointAliases = ['mobile', 'laptop', 'desktop', 'largeDesktop', 'extraDesktop'] as const;

export type BreakpointType = (typeof breakpointAliases)[number];

const sizes: Record<BreakpointType, number> = {
  mobile: 576,
  laptop: 768,
  desktop: 992,
  largeDesktop: 1200,
  extraDesktop: 1400,
};

const getValue = (value: BreakpointType | number) =>
  typeof value === 'number' ? value : sizes[value];

const getMinWidth = (value: BreakpointType | number) => {
  return `(min-width: ${getValue(value)}px)`;
};

const getMaxWidth = (value: BreakpointType | number) => {
  return `(max-width: ${getValue(value) - 1}px)`;
};

const getMediaBefore = (value: BreakpointType | number) => {
  return `@media screen and ${getMaxWidth(getValue(value))}`;
};

const getMediaAfter = (value: BreakpointType | number) => {
  return `@media screen and ${getMinWidth(getValue(value))}`;
};

const media: Record<'after' | 'before', Record<BreakpointType, string>> = {
  before: {
    mobile: getMediaBefore(sizes.mobile),
    laptop: getMediaBefore(sizes.laptop),
    desktop: getMediaBefore(sizes.desktop),
    largeDesktop: getMediaBefore(sizes.largeDesktop),
    extraDesktop: getMediaBefore(sizes.extraDesktop),
  },
  after: {
    mobile: getMediaAfter(sizes.mobile),
    laptop: getMediaAfter(sizes.laptop),
    desktop: getMediaAfter(sizes.desktop),
    largeDesktop: getMediaAfter(sizes.largeDesktop),
    extraDesktop: getMediaAfter(sizes.extraDesktop),
  },
};

export const breakpoints = {
  getValue,
  getMinWidth,
  getMaxWidth,
  getMediaBefore,
  getMediaAfter,
  sizes,
  ...media,
} as const;
